<script>
import Vue from "vue"
import { h } from 'vue'
import { copy } from '@/utils/index'
import render from '@/render/render.js'
import ruleTrigger from '@/render/ruleTrigger.js'
import components from '@/packages'
import { EventHub } from '@/utils'
// 全局注册业务组件
Object.keys(components).map(item => {
    Vue.component(item, components[item])
})
// 读取根目录配置文件
function buildListeners (item) {
    const config = item.__config__
    // 如果props有methods属性
    const methods = this.methods || {}
    const listeners = {}
    // 给methods中的方法绑定this和event
    Object.keys(methods).forEach(key => {
        listeners[key] = (event) => methods[key].call(this, event, this.form)
    })
    // 响应 render.js 中的 vModel $emit('input', val) 并改变表单值
    listeners.input = (event) => setValue.call(this, event, item, config)
    return listeners
}

function setValue(event, scheme, config) {
    // 现在表单渲染是改变props（config）的值触发组件整体重新渲染（有污染） tip: 是否要深拷贝靠触发组件内的data触发整体渲染？ 已修改done
    this.$set(config, 'defaultValue', event)
    this.$set(this.form, scheme.__vModel__, event)
    // 发布事件（计算组件中用到）
    this.eventHub.emit(scheme.__vModel__, event)
}

function renderChildren (h, item) {
    const config = item.__config__ 
    if (!Array.isArray(config.children)) return null
    return renderFormItem.call(this, h, config.children)
}

const design = {
    colFormItem(h, item) {
        const config = item.__config__
        const listeners = buildListeners.call(this, item)
        const { option = {} } = this.$attrs
        const labelWidth = config.labelWidth || option.labelWidth //__config里没有，则取option中的labelWidth，默认120px
        return (
            <el-col span={config.span}>
                <el-form-item label-width={labelWidth ? `${labelWidth}px` : `120px`} prop={item.__vModel__}
                    label={config.showLabel ? config.label : ''}>
                    <render info={this.form} eventHub={this.eventHub} conf={{ ...item, readonly: this.readonly}} {...{ on: listeners, attrs: this.$attrs }} />
                </el-form-item>
            </el-col>
        )
    },
    rowFormItem(h, item) {
        let child = renderChildren.call(this, h, item)
        if(item.type === 'flex') {
            child = (
                <el-row type={item.type} justify={item.justify} align={item.align}>{child}</el-row>
            )
        }
        return (
            <el-col span={item.span}>
                <el-row gutter={item.gutter}>
                    {child}
                </el-row>
            </el-col>
        )
    }
}

function renderFormItem (h, config) {
    return config.map(item => {
        const  { __config__: { layout } } = item
        const fun = design[layout]
        if(fun) {
            return fun.call(this, h, item)
        }
        throw new Error(`__config__里少了layout属性`)
    })
}


function renderFrom (h) {
    const { configCopy, rules, readonly } = this
    const { option = {} } = this.$attrs
    const { labelPosition, labelWidth, size } = option
    return (
        <el-form
            ref="elForm"
            size={size}
            label-position={labelPosition}
            disabled={readonly}
            label-width={`${labelWidth}px`}
            props={{ model: this.form }}
            rules={rules}
        >
            {renderFormItem.call(this, h, configCopy)}
        </el-form>
    )
}

export default {
    name: 'el-dynamic-form',
    props: {
        // 表单 fileds
        formConfig: {
            type: Array,
            required: true
        },
        // 表单model 
        formData: {
            type: Object,
            default: () => {},
        },
        // API配置相关 已经v-bind attr
        // option: {
        //     type: Object,
        //     default: () => {}
        // },
        // 表单额外要监听的方法
        methods: {
            type: Object,
            default: () => {}
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const data = {
            form: {},
            rules: {},
            configCopy: copy(this.formConfig),
            eventHub: new EventHub()
        }
        this.buildRules(data.configCopy, data.rules)
        return data
    },
    watch: {
        formConfig: {
            handler: function (value) {
                if(!value) throw ('formConfig must be required')  
                if(!Array.isArray(value)) throw ('formConfig must an Array')
                // this.buildRules(value, this.rules)
            },
            immediate: true
        },
        formData: {
            handler: function (value) {
                if(value === undefined) return
                const copyValue = copy(value)
                // form赋值并为表单添加默认值
                this.form = this.initFormData(this.configCopy, copyValue)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        initFormData(fields, value) {
            fields.map(item => {
                const itemConfig = item.__config__
                const { defaultValue } = itemConfig
                // 为表单添加默认值
                if(item.__vModel__ && defaultValue) {
                    // 如果该formData有值就不使用默认值
                    if(value[item.__vModel__]) return
                    value[item.__vModel__] = itemConfig.defaultValue
                }
                if (itemConfig.children) this.initFormData(itemConfig.children, value)
            })
            return value
        },
        buildRules(fields, rules) {
            fields.map(field => {
                const config = field.__config__
                if (Array.isArray(config.regList)) {
                    if (config.required) {
                        const required = { required: config.required, message: field.placeholder }
                        required.message === undefined && (required.message = `${config.label}不能为空`)
                        config.regList.push(required)
                    }
                    rules[field.__vModel__] = config.regList.map(item => {
                        item.pattern && (item.pattern = eval(item.pattern))
                        item.trigger = ruleTrigger[config.tag] || 'blur'
                        return item
                    })
                }
                if (config.children) this.buildRules(config.children, rules)
                // const { props } = field
                // // 卡片容器
                // if(field.typeId === 'CARD') {
                //     this.buildRules(props.rows, rules)
                // }
                // // 标签容器
                // if(field.typeId === 'TABS') {
                //     props.tabs.map(item => {
                //         this.buildRules(item.rows, rules)
                //     })
                // }
            })
        },
        submitForm() {
           return this.form
        },
        validate(val) {
            return this.$refs['elForm'].validate(val)
        }
    },
    render(h) {
        return renderFrom.call(this, h)
    }
}
</script>
